import { FunctionComponent, useEffect, useState } from 'react';
import ChecklistApi from '../../api/checklists';
import { ChecklistRtl as ChecklistRtlIcon } from '../icons';
type ChecklistIconProps = {
    tailNumber: string | null,
}

const ChecklistIcon: FunctionComponent<ChecklistIconProps> = ({ tailNumber }) => {

    const [isChecklistOpen, setIsChecklistOpen] = useState<boolean>(false);

    useEffect(() => {
        if (tailNumber !== null) {
            ChecklistApi.GetChecklistStatus(tailNumber).then(res => {
                if (res.status === true) {
                    setIsChecklistOpen(res.status);
                }
                else{
                    setIsChecklistOpen(false);
                }
            });
        }
    }, [tailNumber]);

    if (isChecklistOpen) {
        return (
            <ChecklistRtlIcon className="ml-2 text-[green]" />
        );
    }
    else{
        return (
          <></>
        );
    } 
};
export default ChecklistIcon;